import React from 'react'

import App from './App'

const EditorComponent = (props) => {
  return <App {...props} />
}

export default EditorComponent
